module.exports = __webpack_public_path__ + "static/img/portal-step2-stjustins.70ac9ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/enrol/portal-step2-stjustins.png
// module id = fBwY
// module chunks = 170